<template>
    <div id="navDocument4" class="document" ref="navDocument4">
        <div  class="content" ref="content">
            <div style="text-align:center;">
                <img src="img/merchManual/1.png">
                <img src="img/merchManual/2.png">
                <img src="img/merchManual/3.png">
                <img src="img/merchManual/4.png">
                <img src="img/merchManual/5.png">
                <img src="img/merchManual/6.png">
                <img src="img/merchManual/7.png">
                <img src="img/merchManual/8.png">
                <img src="img/merchManual/9.png">
                <img src="img/merchManual/10.png">
                <img src="img/merchManual/11.png">
                <img src="img/merchManual/12.png">
                <img src="img/merchManual/13.png">
                <img src="img/merchManual/14.png">
                <img src="img/merchManual/15.png">
                <img src="img/merchManual/16.png">
                <img src="img/merchManual/17.png">
                <img src="img/merchManual/18.png">
                <img src="img/merchManual/19.png">
                <img src="img/merchManual/20.png">
                <img src="img/merchManual/21.png">
                <img src="img/merchManual/22.png">
                <img src="img/merchManual/23.png">
                <img src="img/merchManual/24.png" @load="imageLoad">
            </div>
        </div>
    </div>
</template>
<script>

import bScroll from 'better-scroll'

export default {
    data() {
        return {
            bscroll: null
        }
    },
    components: {

    },
    mounted() {
        // this.bscroll = new bScroll(this.$refs.navDocument, {
        //     probeType: 2,
        // });
        // this.bscroll.on("scroll", position=>{
        //     console.log(position);
        // });
        
    },
    beforeDestroy () {
        if(this.bscroll != null) {
            this.bscroll.disable();
            this.bscroll.destroy();
            this.bscroll = null;
        }
    },
    methods: {
        imageLoad() {
            if(this.bscroll != null) {
                this.bscroll.disable();
                this.bscroll.destroy();
                this.bscroll = null;
            }
            this.bscroll = new bScroll(this.$refs.navDocument4, {
                probeType: 2,
                disableMouse: false,//启用鼠标拖动
                disableTouch: false//启用手指触摸
            });
            // this.bscroll.on("scroll", position=>{
            //     console.log("position=" + position);
            // });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/document.scss';
.document {
    img {
        zoom:0.7;
    }
}
</style>
